import React from "react";
import { connect } from "react-redux";

import ProfileUpdate from "../../screens/ProfileUpdate";

import Action from "./action";

const ProfileUpdateContainer = (props) => {
  return (
    <ProfileUpdate
    fetchCountry={props.fetchCountry}
    countryprofdetailList={props.countryprofdetailList}
    fetchregion={props.fetchregion}
    regionList={props.regionList}
    fetchlocation={props.fetchlocation}
    locationList={props.locationList}
    addshipperprofile={props.addshipperprofile}
    addshipperImg={props.addshipperImg}
    />
  );
};
const mapStateToProps = (state) => {
  return {
    ...state.ProfileupdateReducer,
  };
};

export default connect(mapStateToProps, { ...Action })(ProfileUpdateContainer);
